export enum PaymentPlanStatus {
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  DEFAULTED = 'DEFAULTED',
  CANCELLED = 'CANCELLED',
}

export enum PaymentPlanFrequency {
  WEEKLY = 'WEEKLY',
  BIWEEKLY = 'BIWEEKLY',
  MONTHLY = 'MONTHLY',
}

export enum InstallmentStatus {
  PENDING = 'PENDING',
  PAID = 'PAID',
  OVERDUE = 'OVERDUE',
  PARTIALLY_PAID = 'PARTIALLY_PAID',
}

export interface PaymentPlanInstallment {
  id: number;
  paymentPlanId: number;
  installmentNumber: number;
  dueDate: string;
  amount: number;
  paidAmount: number;
  status: InstallmentStatus;
  paidDate?: string | null;
  remarks?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface PaymentPlan {
  id: number;
  rentalContractId: number;
  odooPartnerId?: number;
  contactId?: number;
  companyId?: number;
  status: PaymentPlanStatus;
  totalOutstandingAmount: number;
  totalPlanAmount: number;
  installmentAmount: number;
  frequency: PaymentPlanFrequency;
  numberOfInstallments: number;
  startDate: string;
  remarks?: string | null;
  createdByUserId?: string | null;
  installments: PaymentPlanInstallment[];
  rentalContract?: { id: number };
  contact?: { id: number; firstName: string; lastName: string } | null;
  company?: { id: number; name: string } | null;
  createdAt: string;
  updatedAt: string;
}

export interface PaymentPlanSummary {
  id: number;
  status: PaymentPlanStatus;
  totalPlanAmount: number;
  paidCount: number;
  totalCount: number;
  nextDueDate: string | null;
}

export const PAYMENT_PLAN_STATUS_LABELS: Record<PaymentPlanStatus, string> = {
  [PaymentPlanStatus.ACTIVE]: 'Actief',
  [PaymentPlanStatus.COMPLETED]: 'Voltooid',
  [PaymentPlanStatus.DEFAULTED]: 'In gebreke',
  [PaymentPlanStatus.CANCELLED]: 'Geannuleerd',
};

export const PAYMENT_PLAN_STATUS_COLORS: Record<PaymentPlanStatus, string> = {
  [PaymentPlanStatus.ACTIVE]: 'bg-blue-100 text-blue-800',
  [PaymentPlanStatus.COMPLETED]: 'bg-green-100 text-green-800',
  [PaymentPlanStatus.DEFAULTED]: 'bg-red-100 text-red-800',
  [PaymentPlanStatus.CANCELLED]: 'bg-neutral-100 text-neutral-600',
};

export const PAYMENT_PLAN_FREQUENCY_LABELS: Record<PaymentPlanFrequency, string> = {
  [PaymentPlanFrequency.WEEKLY]: 'Wekelijks',
  [PaymentPlanFrequency.BIWEEKLY]: 'Tweewekelijks',
  [PaymentPlanFrequency.MONTHLY]: 'Maandelijks',
};

export const INSTALLMENT_STATUS_LABELS: Record<InstallmentStatus, string> = {
  [InstallmentStatus.PENDING]: 'In afwachting',
  [InstallmentStatus.PAID]: 'Betaald',
  [InstallmentStatus.OVERDUE]: 'Achterstallig',
  [InstallmentStatus.PARTIALLY_PAID]: 'Gedeeltelijk betaald',
};

export const INSTALLMENT_STATUS_COLORS: Record<InstallmentStatus, string> = {
  [InstallmentStatus.PENDING]: 'bg-yellow-100 text-yellow-800',
  [InstallmentStatus.PAID]: 'bg-green-100 text-green-800',
  [InstallmentStatus.OVERDUE]: 'bg-red-100 text-red-800',
  [InstallmentStatus.PARTIALLY_PAID]: 'bg-orange-100 text-orange-800',
};
